export default [
  {
    label: 'Beds',
    image: 'fall-refresh-bed-1.jpg',
    url: '/c/bedroom-furniture/beds'
  },
  {
    label: 'Chairs',
    // image: 'SKY_9305_CanvasTigresse_02.jpg',
    image: 'SHN_EnglishRollArmChair_WAL_NavyClassicTickingStripe_THEINSIDe.jpg',
    url: '/c/living-room-furniture/chairs'
  },
  {
    label: 'Curtains',
    image: 'new-tall-curtain.jpg',
    url: '/c/home-decor/curtains',
  },
  {
    label: 'Ottomans',
    image: 'new-otto.jpg',
    url: '/c/living-room-furniture/ottomans'
  },
  {
    label: 'Pillows',
    image: 'new-pillow.jpg',
    url: '/c/home-home/throw-pillows'
  },
  {
    label: 'Sofas',
    image: 'new-sofa.jpg',
    url: '/c/living-room-furniture/sofas'
  },
  {
    label: 'Bedding',
    image: 'bedding.jpg',
    url: '/collections/all-bedding'
  },
  {
    label: 'Headboards',
    image: 'new-head.jpg',
    url: '/c/bedroom-furniture/headboards'
  },
  {
    label: 'Coffee & Accent Tables',
    image: 'new-table.jpg',
    url: '/collections/coffee-tables-and-side-tables'
  },
  {
    label: 'Benches',
    image: 'new-bench.jpg',
    url: '/c/living-room-furniture/benches'
  },
  {
    label: 'Table Linens',
    image: 'new-linens.jpg',
    url: '/c/home-decor/table-linens'
  },
  {
    label: 'Rugs',
    image: 'new-rugs.jpg',
    url: '/collections/rugs'
  },
  {
    label: 'Lighting',
    image: 'HVL_DorsetFloorLamp_AgedBrass_01.jpg',
    url: '/collections/lighting',
  },
  {
    label: 'Desk Chairs',
    image: 'new-chairs.jpg',
    url: '/c/office-furniture/desk-chairs'
  },
  // {
  //   label: 'Screens',
  //   image: 'new-screens224.jpg',
  //   url: '/c/home-decor/room-dividers'
  // },

  //
  // {
  //   label: 'Cabana Chairs',
  //   image: '15-cabana_chairs.jpg',
  //   url: '/c/outdoor-furniture/cabana-chairs',
  // },

  {
    label: 'Fabric by The Yard',
    image: '14-fabrics.jpg',
    url: '/c/fabric-by-the-yard/fabric-by-the-yard',
    hoverImg: `https://theinside.imgix.net/misc/fby_holiday_02.gif`,
  },
  {
    label: 'Wallpaper',
    image: 'new-wall.jpg',
    url: '/c/home-decor/wallpaper'
  },

  // {
  //   label: 'Cocktail Ottomans',
  //   image: 'SKY_444_ESP_BlackBarnegatPlaid_01.jpg',
  //   url: '/c/living-room-furniture/cocktail-ottomans'
  // },

];
